// Styles librairies
import 'nouislider/distribute/nouislider.min.css'

// Scripts librairies
import GMaps from '../libs/gmaps/gmaps.min.js'
import MarkerClusterer from '@google/markerclustererplus'
import noUiSlider from 'nouislider'
import wNumb from '../../js/libs/wnumb-1.2.0/wNumb.min.js'

export const groundsPage = {
  $f: $('form[name="ground_filters_form"]'),

  buildMap: function () {
    const $map = $('#map')
    const _this = this
    const datas = {
      search: _this.$f.find('input[name="search"]').val(),
      type: _this.$f.find('input[name="type"]').val(),
      slug: _this.$f.find('input[name="slug"]').val(),
      surface_from: _this.$f.find('input[name="surface_from"]').val(),
      surface_to: _this.$f.find('input[name="surface_to"]').val(),
      budget_from: _this.$f.find('input[name="budget_from"]').val(),
      budget_to: _this.$f.find('input[name="budget_to"]').val()
    }
    const markers = []
    let map
    let center

    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: '/terrains-a-batir/get',
      data: datas,
      success: function (response) {
        let countGrounds = 0
        let countCities = 0
        let title
        let latLng
        let marker
        const icon = '/assets/img/icons/map-marker-offer.png'
        const iconCurrent = '/assets/img/icons/map-marker-current-offer.png'

        // affiche les terrains de tous les départements
        if (response.type === 'all') {
          if (typeof (response.listing) !== 'undefined') {
            /* global google */
            center = new google.maps.LatLng(47.2186371, -1.5541362)
            map = new google.maps.Map($map[0], {
              zoomControl: true,
              maxZoom: 13,
              center: center,
              scrollwheel: false,
              streetViewControl: false,
              panControl: false,
              mapTypeControl: false,
              draggable: true,
              disableDoubleClickZoom: false,
              keyboardShortcuts: false,
              mapTypeId: google.maps.MapTypeId.ROADMAP
            })
          }

          $.each(response.listing, function (i, elem) {
            countGrounds += parseInt(elem.total)
            title = elem.total === 0 ? 'aucun terrain' : (elem.total === 1 ? '1 terrain' : elem.total + ' terrains')
            latLng = new google.maps.LatLng(elem.lat, elem.lon)
            marker = new google.maps.Marker({
              position: latLng,
              icon: icon,
              title: elem.city + ' : ' + title,
              link: elem.link
            })
            marker.setAnimation(google.maps.Animation.BOUNCE)
            markers.push(marker)
            google.maps.event.addListener(marker, 'click', function () { document.location.href = '/terrains-a-batir/' + this.link })
            countCities++
          })

          const countCitiesS = countCities > 0 ? (countCities === 1 ? 'dans 1 commune' : 'dans ' + countCities + ' communes') : ''
          const countGroundsS = countGrounds > 0 ? (countGrounds === 1 ? '1 terrain' : countGrounds + ' terrains') : 'aucun terrain'
          if (countCities === 0 && countGrounds === 0) {
            $('.count').text('aucun terrain')
          } else {
            $('.count').text(countGroundsS + ' ' + countCitiesS)
          }
        }

        // affiche les terrains à proximité de la ville
        if (response.type === 'city') {
          if (typeof (response.listing) !== 'undefined') {
            center = new google.maps.LatLng($map.attr('map-lat'), $map.attr('map-lng'))
            map = new google.maps.Map($map[0], {
              zoomControl: true,
              zoom: 11,
              maxZoom: 13,
              center: center,
              scrollwheel: false,
              streetViewControl: false,
              panControl: false,
              mapTypeControl: false,
              draggable: true,
              disableDoubleClickZoom: false,
              keyboardShortcuts: false,
              mapTypeId: google.maps.MapTypeId.ROADMAP
            })
          }

          // ajoute le marker de la ville recherchée
          marker = new google.maps.Marker({
            position: center,
            icon: iconCurrent,
            title: _this.$f.find('input[name="search"]').val()
          })
          marker.setAnimation(google.maps.Animation.BOUNCE)
          markers.push(marker)
          $.each(response.listing, function (i, elem) {
            countGrounds += parseInt(elem.total)
            title = elem.total === 0 ? 'aucun terrain' : (elem.total === 1 ? '1 terrain' : elem.total + ' terrains')
            latLng = new google.maps.LatLng(elem.lat, elem.lon)
            if (elem.link !== _this.$f.find('input[name="slug"]').val()) {
              marker = new google.maps.Marker({
                position: latLng,
                icon: icon,
                title: elem.city + ' : ' + title,
                link: elem.link
              })
              markers.push(marker)
              google.maps.event.addListener(marker, 'click', function () {
                document.location.href = '/terrains-a-batir/' + this.link
              })
            }
            countCities++
          })
        }

        const clusterStyles = [
          {
            textColor: '#222',
            textSize: '15',
            fontFamily: 'Poppins',
            url: '/assets/img/icons/o1.png',
            height: 52,
            width: 51
          },
          {
            textColor: '#222',
            textSize: '15',
            fontFamily: 'Poppins',
            url: '/assets/img/icons/o2.png',
            height: 56,
            width: 55
          },
          {
            textColor: '#222',
            textSize: '15',
            fontFamily: 'Poppins',
            url: '/assets/img/icons/o3.png',
            height: 65,
            width: 64
          },
          {
            textColor: '#222',
            textSize: '15',
            fontFamily: 'Poppins',
            url: '/assets/img/icons/o4.png',
            height: 78,
            width: 77
          },
          {
            textColor: '#222',
            textSize: '15',
            fontFamily: 'Poppins',
            url: '/assets/img/icons/o5.png',
            height: 90,
            width: 89
          }
        ]

        // dessine la carte ou affiche un message
        if (countGrounds > 0) {
          const mc = new MarkerClusterer(map, markers, {
            styles: clusterStyles
          })
          if (response.type === 'all') {
            mc.fitMapToMarkers()
            if (countCities === 1) { // si 1 seule ville, on dézoome pour éviter un zoom trop fort après le fit des clusters sur la map
              const listener = google.maps.event.addListener(map, 'idle', function () {
                if (map.getZoom() > 16) map.setZoom(12)
                google.maps.event.removeListener(listener)
              })
            }
          }
        } else {
          $map.html('<div class="p-4" role="alert">' +
              '<p class="large">' +
                '<b>Il n\'y a actuellement aucun terrain constructible disponible.</b> Nous vous invitons à modifier vos critères de recherche ou à vous inscrire à une alerte terrain du département de votre choix pour être tenu informé de l\'ajout de nouvelles offres correspondant à vos critères.' +
              '</p>' +
              '<a href="/terrains-a-batir/alerte-terrain" class="btn btn-primary btn-lg">S\'inscrire à une alerte terrain</a>' +
            '</div>')
        }
      }
    })
  },

  init: function () {
    const _this = this
    if (_this.$f.length) {
      // superficie
      _this.$f.each(function () {
        const range = $(this).find('.surface-range')[0]
        const skipValues = [
          $(this).find('.surface-value-min')[0],
          $(this).find('.surface-value-max')[0]
        ]
        const inputValues = [
          $(this).find('input[name="surface_from"]')[0],
          $(this).find('input[name="surface_to"]')[0]
        ]
        const minv = parseInt($(this).find('input[name="surface_min"]').val())
        const maxv = parseInt($(this).find('input[name="surface_max"]').val())
        const moneyFormat = wNumb({
          decimals: 0,
          thousand: '.',
          postfix: ' m²'
        })
        noUiSlider.create(range, {
          start: [minv, maxv],
          connect: true,
          step: 100,
          range: {
            min: minv,
            max: maxv
          },
          format: moneyFormat
        })

        if (inputValues[0].value !== '' && inputValues[1].value !== '') {
          range.noUiSlider.set([inputValues[0].value, inputValues[1].value]) // affecte les valeurs
        } else {
          range.noUiSlider.set([minv, maxv]) // affecte les valeurs par défaut
        }
        range.noUiSlider.on('update', function (values, handle) { // relie le snap aux inputs
          skipValues[handle].innerHTML = values[handle]
          if (moneyFormat.from(values[handle]) === maxv) {
            skipValues[handle].innerHTML = values[handle] + ' et +'
          }
          inputValues[handle].value = moneyFormat.from(values[handle])
        })
      })

      // budget
      _this.$f.each(function () {
        const budgetRange = $(this).find('.budget-range')[0]
        const skipValues = [
          $(this).find('.budget-value-min')[0],
          $(this).find('.budget-value-max')[0]
        ]
        const inputValues = [
          $(this).find('input[name="budget_from"]')[0],
          $(this).find('input[name="budget_to"]')[0]
        ]
        const minv = parseInt($(this).find('input[name="budget_min"]').val())
        const maxv = parseInt($(this).find('input[name="budget_max"]').val())
        const moneyFormat = wNumb({
          decimals: 0,
          thousand: '.',
          postfix: ' €'
        })
        noUiSlider.create(budgetRange, {
          start: [minv, maxv],
          connect: true,
          step: 10000,
          range: {
            min: minv,
            max: maxv
          },
          format: moneyFormat
        })
        if (inputValues[0].value !== '' && inputValues[1].value !== '') {
          budgetRange.noUiSlider.set([inputValues[0].value, inputValues[1].value]) // affecte les valeurs
        } else {
          budgetRange.noUiSlider.set([minv, maxv]) // affecte les valeurs par défaut
        }
        budgetRange.noUiSlider.on('update', function (values, handle) { // relie le snap aux inputs
          skipValues[handle].innerHTML = values[handle]
          if (moneyFormat.from(values[handle]) === maxv) {
            skipValues[handle].innerHTML = values[handle] + ' et +'
          }
          inputValues[handle].value = moneyFormat.from(values[handle])
        })
      })

      // formulaire de recherche des terrains depuis le listing
      _this.$f.on('submit', function () {
        const action = $(this).attr('action')
        if ($(this).find('input[name="type"]').val() !== '') { $(this).attr('action', action + '/' + $(this).find('input[name="slug"]').val()) }
      })
    }

    // event sur bouton financement projet : track event google analytics
    $('#track-financing').on('click', function () {
      /* global ga */
      if (typeof (googleanalytics) !== 'undefined') { ga('send', 'event', 'Financement terrain', 'Clic') }
      /* global gtag */
      if (typeof (googletag) !== 'undefined') { gtag('event', 'financing', { element: 'ground' }) }
    })

    // event sur bouton contact : track event google analytics
    $('#track-contact').on('click', function () {
      if (typeof (googleanalytics) !== 'undefined') { ga('send', 'event', 'Contacter terrain', 'Clic') }
      if (typeof (googletag) !== 'undefined') { gtag('event', 'contact', { subject: 'ground' }) }
    })

    // event sur bouton modèle : track event google analytics
    $('#track-model').on('click', function () {
      if (typeof (googleanalytics) !== 'undefined') { ga('send', 'event', 'Recherche modele', 'Clic') }
      if (typeof (googletag) !== 'undefined') { gtag('event', 'find_model') }
    })

    // scroll pour les ancres de page
    $('.go').on('click', function () {
      const t = $(this).attr('target')
      $('html, body').animate({
        scrollTop: ($(t).offset().top - $('#navigation4').height())
      }, 500)
    })
    // ancre automatique si submit des filtres
    if ($('#go').length) {
      const t = $('#go').val()
      $('html, body').animate({
        scrollTop: ($(t).offset().top - $('#navigation4').height())
      }, 500)
    }
  },

  initMap: function () {
    const _this = this
    const $map = $('#map-detail')
    // fabrique la map et les clusters
    if ($('#map').length) {
      this.buildMap()
    } else if ($map.length) {
      $map.waypoint(function () {
        const map = new GMaps({
          div: '#' + $map.attr('id'),
          zoom: 10,
          scrollwheel: false,
          draggable: false,
          lat: $map.attr('map-lat'),
          lng: $map.attr('map-lng')
        })
        const marker = map.addMarker({
          icon: '/assets/img/icons/map-marker-current-offer.png',
          lat: $map.attr('map-lat'),
          lng: $map.attr('map-lng'),
          title: $map.attr('map-title')
        })
        marker.setAnimation(google.maps.Animation.BOUNCE)
        this.destroy()
      }, {
        offset: '100%'
      })
    }
  }

}
